import { useTheme } from 'styled-components'

import { Breadcrumbs } from '@components/Breadcrumbs'

import {
  Wrapper,
  TextWrapper,
  Title,
  SideImage,
  SoftStarLeft,
  SoftStarRight,
} from './styles'
import { PageHeaderProps } from './types'

export function PageHeader({ title, sideImage }: PageHeaderProps) {
  const { newColors } = useTheme()

  return (
    <Wrapper>
      <Breadcrumbs textColor={newColors.lightOrange} />
      <SideImage {...sideImage} />
      <TextWrapper>
        <Title as="h1">{title}</Title>
      </TextWrapper>
      <SoftStarLeft />
      <SoftStarRight />
    </Wrapper>
  )
}
